<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Flote"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Nume">
                <el-input v-model="Filters.Nume" />
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      <el-table-column label="#" width="44px">
        <template slot-scope="scope">
          <!-- <el-tooltip :content="'Id client EVIO: ' + scope.row.IdClientEvio"> -->
            <span>{{scope.row.Id}}</span> 
          <!-- </el-tooltip> -->
        </template>
      </el-table-column>
      <el-table-column prop="Nume" label="Nume"></el-table-column>
      <el-table-column prop="Cui" label="Cui"></el-table-column>
      <el-table-column prop="Email" label="Email"></el-table-column>
      <el-table-column prop="IdClientEvio" label="Id Evio"></el-table-column>
      <!-- <el-table-column prop="RegCom" label="Nr Reg Com"></el-table-column> -->
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Modificare">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delete_item(scope.row)"
            /> </el-tooltip></template></el-table-column
    ></el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager" />
    <Firme-flote-dialog class="custom-width" ref="dlg" @save="refresh_info()"
  /></base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Firme_flote_dialog from "@/pages/Admin/flote/Firme_flote_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "firme_flote",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Firme-flote-dialog": Firme_flote_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Nume: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },

  
  methods: {
    async get_info() {
      var response = await this.post("admin/flote/get_info_firme");
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/flote/index_firme", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("flote");
    },
    reset() {
      this.Filters = {
        Nume: "",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("admin/flote/delete_item_firme", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management") && !this.$has_right("Supervizor")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 5%;
  width: 45%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
